export default "__VITE_ASSET__JNXyNyjo__"